const Joi = require("joi");
const ValidationTranslateFile = require("../Loc/ValidationTranslateFile.jsx");
const currentLang = ValidationTranslateFile()

const PublicDefenderServiceFormSchema = (data) => {
    const schema = Joi.object({
        countyName: Joi.string()
            .required()
            .trim()
            .messages({
                "string.empty": currentLang?.ValidationSchema?.Form_Field_Required,
                "any.required": currentLang?.ValidationSchema?.The_Field_Required,
            }),
        address: Joi.string()
            .required()
            .trim()
            .messages({
                "string.empty": currentLang?.ValidationSchema?.Form_Field_Required,
                "any.required": currentLang?.ValidationSchema?.The_Field_Required,
            }),
        guardianAddress: Joi.string()
            .required()
            .trim()
            .messages({
                "string.empty": currentLang?.ValidationSchema?.Form_Field_Required,
                "any.required": currentLang?.ValidationSchema?.The_Field_Required,
            }),
        city: Joi.string()
            .required()
            .trim()
            .messages({
                "string.empty": currentLang?.ValidationSchema?.Form_Field_Required,
                "any.required": currentLang?.ValidationSchema?.The_Field_Required,
            }),
        state: Joi.number()
            .required()
            .messages({
                "any.required": currentLang?.ValidationSchema?.Form_Field_Required,
                "number.base": currentLang?.ValidationSchema?.Form_Field_Required,
            }),
        zip: Joi.string()
            .required()
            .trim()
            .messages({
                "string.empty": currentLang?.ValidationSchema?.Form_Field_Required,
                "any.required": currentLang?.ValidationSchema?.The_Field_Required,
            }),
        ssnFirst: Joi.number()
            .required()
            .messages({
                "any.required": currentLang?.ValidationSchema?.Form_Field_Required,
                "number.base": currentLang?.ValidationSchema?.Form_Field_Required,
            }),
        ssnSecond: Joi.number()
            .required()
            .messages({
                "any.required": currentLang?.ValidationSchema?.Form_Field_Required,
                "number.base": currentLang?.ValidationSchema?.Form_Field_Required,
            }),
        ssnThird: Joi.number()
            .required()
            .messages({
                "any.required": currentLang?.ValidationSchema?.Form_Field_Required,
                "number.base": currentLang?.ValidationSchema?.Form_Field_Required,
            }),
        guardianName: Joi.string()
            .required()
            .trim()
            .messages({
                "string.empty": currentLang?.ValidationSchema?.Form_Field_Required,
                "any.required": currentLang?.ValidationSchema?.The_Field_Required,
            }),
        maritalStatus: Joi.number()
            .required()
            .messages({
                "number.base": currentLang?.ValidationSchema?.Form_Field_Required,
                "any.required": currentLang?.ValidationSchema?.The_Field_Required,
            }),
        netIncome: Joi.number()
            .required()
            .messages({
                "any.required": currentLang?.ValidationSchema?.Form_Field_Required,
                "number.base": currentLang?.ValidationSchema?.Form_Field_Required,
            }),
        caseTotal: Joi.string()
            .required()
            .messages({
                "any.required": currentLang?.ValidationSchema?.Form_Field_Required,
                "number.base": currentLang?.ValidationSchema?.Form_Field_Required,
            }),
        isDisabled: Joi.number()
            .required()
            .messages({
                "any.required": currentLang?.ValidationSchema?.Form_Field_Required,
                "number.base": currentLang?.ValidationSchema?.Form_Field_Required,
            }),
        receivesBenefits: Joi.number()
            .required()
            .messages({
                "any.required": currentLang?.ValidationSchema?.Form_Field_Required,
                "number.base": currentLang?.ValidationSchema?.Form_Field_Required,
            }),
        employed: Joi.number()
            .required()
            .messages({
                "any.required": currentLang?.ValidationSchema?.Form_Field_Required,
                "number.base": currentLang?.ValidationSchema?.Form_Field_Required,
            }),

        incomeInJail: Joi.number()
            .required()
            .messages({
                "any.required": currentLang?.ValidationSchema?.Form_Field_Required,
                "number.base": currentLang?.ValidationSchema?.Form_Field_Required,
            }),
        pdsInmateSignature: Joi.string()
            .required()
            .trim()
            .messages({
                "string.empty": currentLang?.ValidationSchema?.Form_Field_Required,
                "any.required": currentLang?.ValidationSchema?.The_Field_Required,
            }),
        acknowledgeMent: Joi.valid(true)
            .required()
            .messages({
                "any.only": currentLang?.ValidationSchema?.Form_Field_Required, // Custom error for non-true values
                "any.required": currentLang?.ValidationSchema?.Form_Field_Required, // Custom error for missing field
            }),
        spouseName: Joi.string()
            .trim()
            .when('maritalStatus', {
                is: 4,
                then: Joi.string().required().messages({
                    "string.empty": currentLang?.ValidationSchema?.spouseName_Required,
                    "any.required": currentLang?.ValidationSchema?.spouseName_Required,
                }),
                otherwise: Joi.string().allow('').optional(), // Allow an empty string or ignore for other statuses
            }),
        spouseEmployedWhere: Joi.string()
            .trim()
            .when('spouseEmployed', {
                is: 1,
                then: Joi.string().required().messages({
                    "string.empty": currentLang?.ValidationSchema?.The_Field_Required,
                    "any.required": currentLang?.ValidationSchema?.The_Field_Required,
                }),
                otherwise: Joi.allow('').optional(), // For other statuses
            }),
        netIncomeType: Joi.alternatives().conditional('netIncome', {
            is: Joi.string().pattern(/^\s*$/).not('').required(), // Ensures `netIncome` is not an empty string or only spaces
            then: Joi.string().allow('').optional(), // If `netIncome` is empty or just spaces, allow `netIncomeType` as empty or string
            otherwise: Joi.number().required().messages({
                "number.base": currentLang?.ValidationSchema?.The_Field_Required,
                "any.required": currentLang?.ValidationSchema?.The_Field_Required,
            }),
        }),
        disabilityType: Joi.alternatives().conditional('isDisabled', {
            is: 1, // If maritalStatus is 4
            then: Joi.string().required().messages({
                "string.empty": currentLang?.ValidationSchema?.Form_Field_Required,
                "any.required": currentLang?.ValidationSchema?.The_Field_Required,
            }),
            otherwise: Joi.string().allow('').optional(), // For other statuses
        }),
        employerDetails: Joi.string()
            .trim()
            .when('employed', {
                is: 1,
                then: Joi.string().required().messages({
                    "string.empty": currentLang?.ValidationSchema?.Form_Field_Required,
                    "any.required": currentLang?.ValidationSchema?.Form_Field_Required,
                }),
                otherwise: Joi.string().allow('').optional(), // Allow an empty string or ignore for other statuses
            }),
        jobTitle: Joi.string()
            .trim()
            .when('employed', {
                is: 1,
                then: Joi.string().required().messages({
                    "string.empty": currentLang?.ValidationSchema?.Form_Field_Required,
                    "any.required": currentLang?.ValidationSchema?.Form_Field_Required,
                }),
                otherwise: Joi.string().allow('').optional(), // Allow an empty string or ignore for other statuses
            }),
        lengthOfJob: Joi.string()
            .trim()
            .when('employed', {
                is: 1,
                then: Joi.string().required().messages({
                    "string.empty": currentLang?.ValidationSchema?.Form_Field_Required,
                    "any.required": currentLang?.ValidationSchema?.Form_Field_Required,
                }),
                otherwise: Joi.string().allow('').optional(), // Allow an empty string or ignore for other statuses
            }),

        incomeInJailAmount: Joi.string()
            .trim()
            .when('incomeInJail', {
                is: 1,
                then: Joi.string().required().messages({
                    "string.empty": currentLang?.ValidationSchema?.Form_Field_Required,
                    "any.required": currentLang?.ValidationSchema?.Form_Field_Required,
                }),
                otherwise: Joi.string().allow('').optional(), // Allow an empty string or ignore for other statuses
            }),
        benefitsAmount: Joi.string()
            .trim()
            .when('receivesBenefits', {
                is: 1,
                then: Joi.string().required().messages({
                    "string.empty": currentLang?.ValidationSchema?.Form_Field_Required,
                    "any.required": currentLang?.ValidationSchema?.Form_Field_Required,
                }),
                otherwise: Joi.string().allow('').optional(), // Allow an empty string or ignore for other statuses
            }),

    }).unknown(true);

    return schema.validate(data, {
        abortEarly: false, // Shows all validation errors instead of stopping at the first error
    });
};

module.exports = PublicDefenderServiceFormSchema;
